export default {
  DIVIDE: 'DIVIDE',
  METADATA: 'METADATA',
  METADATA_ALL: 'METADATA_ALL',
}
